import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFacilitiesSubMenu = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_8930_59989)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M11.262 7.429h6.015V16h-6.015V7.43Z",
				stroke: "#748094",
				strokeWidth: 1.2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 13.066,
				y: 9.265,
				width: 2.406,
				height: 1,
				rx: .5,
				fill: "#748094"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.844 4h8.42v12h-8.42V4Z",
				stroke: "#748094",
				strokeWidth: 1.2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 5.367,
				y: 6.571,
				width: 3.368,
				height: 1,
				rx: .5,
				fill: "#748094"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2 16h16",
				stroke: "#748094",
				strokeWidth: 1.2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_8930_59989",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h20v20H0z"
		})
	}) })]
});
export default SvgFacilitiesSubMenu;
